/**
 * As duas decisões da 1ª ativação do WhatsApp, fora do componente para poderem ser testadas.
 *
 * Por que isto virou módulo: `npm run build` compila JSX, não executa. Um `if` errado aqui não
 * quebra build nenhum — ele só aparece como "a modal não abriu" ou, pior, "a modal abre toda vez
 * que eu ligo o WhatsApp".
 */

/**
 * Deve pedir o telefone do dono?
 *
 * Só ao LIGAR e só quando não há número salvo. Desligar, religar com número já guardado, ou
 * qualquer outro caminho segue direto — a modal é de primeira vez, não de toda vez.
 *
 * @param {boolean} ligando  para onde o botão está indo
 * @param {string|null|undefined} telefoneSalvo  o que já está no cadastro
 */
export function devePedirTelefone(ligando, telefoneSalvo) {
  return ligando === true && !String(telefoneSalvo ?? '').trim();
}

/**
 * O número serve para enviar?
 *
 * Aceita 10 ou 11 dígitos, com ou sem o 55 na frente, com ou sem máscara. A API normaliza de
 * novo e é ela quem manda — esta checagem existe só para não gastar uma ida ao servidor e um
 * erro genérico quando a pessoa esqueceu o DDD.
 *
 * @param {string} valor  o que foi digitado
 */
export function telefoneServeParaEnvio(valor) {
  const digitos = String(valor ?? '').replace(/\D/g, '');
  const local = digitos.startsWith('55') && digitos.length >= 12 ? digitos.slice(2) : digitos;
  return local.length === 10 || local.length === 11;
}
